export default "__VITE_ASSET__9048a202__"